<template>
  <div class="partitionLine">
    <div id="container">
      <!--划分段数的展示,划分栏直接在样式中画出来了-->
      <div class="lineContainer">
        <div id="line" :style="style" >
          <!--最大值展示-->
          <span class="endLabel max">最大值：{{this.maxValue}}</span>

          <!--划分点-->
          <template v-for="point in pointList">
            <div class="point" :id="'point-' + point.id" :style="{bottom: point.positionPercent*100 + '%'}"
                 @mousedown="pointDragStart($event, point)" @click.stop
                 @mouseover="pointMouseOver(point)" @mouseleave="pointMouseLeave(point)"
                 :class="{'hovered': point.hovered}"
                 :key="point.id"
            >
              <!--在旁边展示的划分点的值-->
              <span class="pointValueLabel">{{point.value}}</span>
            </div>
          </template>

          <!--最小值-->
          <span class="endLabel min">最小值：{{this.minValue}}</span>
        </div>
      </div>

      <!--展示具体的值-->
      <div class="rules">
        <!--展示出最大值-->
        <div class="rulesPoint">
          <span class="ruleLabel">最大值：</span>
          <span class="ruleValue">{{maxValue}}</span>
        </div>

        <!--标记了节点后渲染对应的节点值和区间值-->
        <template v-for="point in pointList">
          <!--渲染区间值-->
          <div class="gtValue" :key="point.id">
            <span class="ruleLabel">{{label}}：</span>
            <span class="ruleValue">
              <!--绑定当前节点上面的区间值-->
              <editable-input
                :component="component" :selectList="selectList" :radioList="radioList"
                v-model="points[point.id].gtValue">
              </editable-input>
            </span>
          </div>
          <div class="rulesPoint" :class="{'hovered': points[point.id].hovered}"
               @mouseover="pointMouseOver(points[point.id])"
               @mouseleave="pointMouseLeave(points[point.id])"
               :key="point.value"
          >
            <span class="ruleLabel">节点：</span>
            <span class="ruleValue">
              <editable-input
                  v-model="points[point.id].value"
                  @input="setPosition(points[point.id])"
                  component="el-input">
              </editable-input>
            </span>
            <span class="deletePointBtn" @click="deletePoint(point.id)">
              <el-icon name="delete"></el-icon>
            </span>
          </div>
        </template>

        <!-- 默认有个区间值,大于最小值,小于最小设置的节点值-->
        <div class="gtValue">
          <span class="ruleLabel">{{label}}：</span>
          <span class="ruleValue">
            <editable-input :component="component" :selectList="selectList" :radioList="radioList" v-model="gtValueMin">
            </editable-input>
          </span>
        </div>
        <!-- 最小值-->
        <div class="rulesPoint">
          <span class="ruleLabel">最小值：</span>
          <span class="ruleValue">{{minValue}}</span>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>

<script>
import deepClone from "../../../../config/deepCopy.js";
import EditableInput from "./EditableInput";
// eslint-disable-next-line no-unused-vars
function getElementToPageTop(el) {
  if(el.parentElement) {
    return getElementToPageTop(el.parentElement) + el.offsetTop
  }
  return el.offsetTop
}
export default {
  name: "PartitionLine",          // 分段的组件
  components: {EditableInput},
  props: {
    selectList: Array,
    radioList: Array,
    value: {
      type: Array,
      default() {
        return []
      }
    },
    maxValue: {     // 分段的最大值
      type: Number,
      default: 100
    },
    minValue: {    // 分段的最小值
      type: Number,
      default: 0
    },
    height: {
      type: String,
      default: '400px'
    },
    component: String,        // 从变量绑定框传来的,用于显示输入框
    equipartitionNum: String,  // 均分 分段数
    label: String,
  },
  data() {
    return {
      pointId: 1,            // 记录划分点的id
      gtValueMin: undefined,   // 最小的区间值
      points: {}           // 记录划分点信息
    }
  },
  mounted() {
    //console.log("当前绑定变量的component是",this.component)
    document.getElementById("line").addEventListener('click', this.handleClick)   // 给划分栏绑定点击事件
    this.value.forEach(rule => {
      if(rule.value === this.minValue) {
        this.gtValueMin = rule.gtValue
        return
      }
      let positionPercent = (rule.value - this.minValue) / (this.maxValue - this.minValue)
      this.$set(this.points, this.pointId, {
        id: this.pointId,
        value: Number.parseFloat(rule.value),
        gtValue: rule.gtValue,
        positionPercent,
        hovered: false
      })
      // this.points[this.pointId] = {
      //   value: rule.value,
      //   gtValue: rule.gtValue,
      //   positionPercent,
      // }
      this.pointId++
    })
    // 根据要展示的不同组件,设置最小区间的默认值
    if(this.gtValueMin === undefined)
    if(this.component === 'color-picker-component') this.gtValueMin = '#000000'
    else if(this.component === 'el-input') this.gtValueMin = ''
    else if(this.component === 'radio-component') this.gtValueMin = '请选择...'
    else if(this.component === 'el-switch') this.gtValueMin = '请选择...'
    else if(this.component === 'select-component') this.gtValueMin = '请选择...'
    else this.gtValueMin = 0
  },
  methods: {
    // 在分段栏点击了一下,新增一个节点
    handleClick(e) {
      let lineDom = document.getElementById('line')
      let height = lineDom.clientHeight
      let offsetY = e.layerY
      let disFromBottom = height - offsetY
      let positionPercent = disFromBottom / height    // 根据点击位置计算出百分比
      //console.log(123,this.component)
      let gtValueTmp
      // 根据值的不同，展示不同的默认值,节点的区间值
      if(this.component === 'color-picker-component') gtValueTmp = '#000000'
      else if(this.component === 'el-input') gtValueTmp = ''
      else if(this.component === 'radio-component') gtValueTmp = '请选择...'
      else if(this.component === 'el-switch') gtValueTmp = '请选择...'
      else if(this.component === 'select-component') gtValueTmp = '请选择...'
      else gtValueTmp = 0
      this.$set(this.points, this.pointId, {    // 新增节点
        id: this.pointId,
        positionPercent,
        value: Number.parseFloat(this.minValue + (this.maxValue - this.minValue) * positionPercent),  // 根据百分比计算值当前的节点值
        gtValue: gtValueTmp,
        hovered: false,
      })
      this.pointId++   // 节点id增加
    },
    deletePoint(pointId) {
      //console.log("点击了删除")
      this.$delete(this.points, pointId)
    },
    pointMouseOver(point) {
      point.hovered = true
    },

    pointMouseLeave(point) {
      point.hovered = false
    },

    setPosition(point) {
      point.positionPercent = (point.value - this.minValue) / (this.maxValue - this.minValue)
    },
    // 点拖拽更新值
    pointDragStart(e, pointItem) {
      let containerDom = document.getElementById('container');

      let lineDom = document.getElementById('line');
      // let lineDomOffsetTop = getElementToPageTop(lineDom);
      //let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      document.onmousemove = (e) => {
        if(e.target.classList.contains('point') || e.target.classList.contains('pointValueLabel')) {
          return
        }
        console.log(e.layerY, e, e.target);

        let height = lineDom.clientHeight
        //scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        let offsetY = e.layerY
        if(e.target === containerDom) {
          offsetY -= containerDom.offsetTop
        }
        let disFromBottom = height - offsetY
        pointItem.positionPercent = disFromBottom / height
        if(pointItem.positionPercent > 1) {
          pointItem.positionPercent = 1
        } else if(pointItem.positionPercent < 0) {
          pointItem.positionPercent = 0
        }
        pointItem.value = Number.parseFloat(this.minValue + (this.maxValue - this.minValue) * pointItem.positionPercent)
        this.$set(this.points, pointItem.id, pointItem)
      }
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  },
  computed: {
    style() {
      return {
        height: this.height,
        background: '-webkit-linear-gradient(270deg, rgba(210,210,210,1), rgba(250,250,250,1))'
      }
    },
    pointList: {      // pointList下标从0开始,点击的划分点信息
      get() {
        let pointList = []
        for(let id in this.points) {
          pointList.push(this.points[id])
        }
        pointList.sort((p1, p2) => {
          return p2.positionPercent - p1.positionPercent
        })
        return pointList
      }
    },
    ruleList() {
      return [{
        value: this.minValue,
        gtValue: this.gtValueMin,
      }, ...this.pointList].map(p => {
        return {
          value: Number.parseFloat(p.value),
          gtValue: p.gtValue
        }
      })
    },
  },
  watch: {
    equipartitionNum: {    // 设置均分
      handler() {
        if(this.equipartitionNum !== undefined) {
          let num = parseInt(this.equipartitionNum)
         // console.log("num = ", num)
          let newPoints = {}
          let count = 1  // 最小值段 初始区间 0
          for(let id in this.points) {  // 当points里有部份，填入
            if(count < num){
              let newPoint = deepClone(this.points[id])
              newPoint["positionPercent"] = count/num
              newPoint["value"] = this.minValue+count*((this.maxValue-this.minValue)/num)
              newPoints[id] = newPoint
            }
            count++
          }
         // console.log("points里有部份 newPoints = ", newPoints)
          while(count < num){  // 缺少的段数
            let gtValueTmp
            if(this.component === 'color-picker-component') gtValueTmp = '#000000'
            else if(this.component === 'el-input') gtValueTmp = ''
            else if(this.component === 'radio-component') gtValueTmp = '请选择...'
            else if(this.component === 'el-switch') gtValueTmp = '请选择...'
            else if(this.component === 'select-component') gtValueTmp = '请选择...'
            else gtValueTmp = 0
            let newPoint = {
              positionPercent: count/num,
              value: this.minValue+count*((this.maxValue-this.minValue)/num),
              gtValue: gtValueTmp,
              id: count,
              hovered: false
            }
            newPoints[count] = newPoint
            count++
          }
          // console.log("补上缺少的 newPoints = ", newPoints)
          this.points = deepClone(newPoints)
          //console.log("points = ", this.points)
        }
      }
    },
    ruleList: {
      handler(val) {
        this.$emit('input', val)
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.partitionLine {
  #container {
    margin-top: 30px;
    .lineContainer {
      float: left;
      display: flex;
      justify-content: center;
      #line {
        display: flex;
        justify-content: center;
        position: relative;
        width: 15px;
        border: 1px solid rgba(210,210,210,1);
        border-radius: 15px;
        .point {
          position: absolute;
          width: 25px;
          left: -5px;
          height: 8px;
          border-radius: 5px;
          background: black;
          transform: translateY(50%);

          &.hovered {
            width: 35px;
            left: -10px;
          }

        }
        .endLabel {
          position: absolute;
          white-space: nowrap;
          font-weight: bolder;
          &.max {
            top: -35px;
          }
          &.min {
            bottom: -35px;
          }
        }
        .pointValueLabel {
          display: inline-block;
          position: relative;
          top: -12px;
          right: -35px;
          max-width: 4em;
          width: 4em;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &.max {

          }
          &.min {

          }
        }

      }
    }
    .rules {
      margin-left: 100px;
      width: 300px;
      float: left;
      display: flex;
      flex-direction: column;
      justify-content: center;
      //align-items: center;

      .ruleLabel {
        float: left;
        width: 6em;
        font-weight: bolder;
      }
      .ruleValue {
        text-align: right;
        float: right;
        width: 50%;
        cursor: text;
      }

      .gtValue {
        padding: 0 15px;
        &.hovered {
          border-radius: 5px;
          background-color: #d7d7d7;
        }
        .ruleLabel {
          padding-left: 20px;
        }
      }
      .rulesPoint {
        position: relative;
        padding: 0 15px;
        &.hovered {
          border-radius: 5px;
          background-color: #d7d7d7;
        }
        .deletePointBtn {
          position:absolute;
          right: -20px;
          cursor: pointer;
        }
      }
    }

  }
}
</style>